import type { Workspace } from "@/api/client";

export type Feature = "lot_serial" | "zone_picking" | "recorder_agent" | "finance";

// Mirrors backend/internal/platform/plan: the server enforces it, this only
// decides what the UI offers.
const features: Record<Workspace["plan"], Feature[]> = {
  trial: ["lot_serial", "zone_picking", "recorder_agent", "finance"],
  free: [],
  growth: ["finance"],
  scale: ["lot_serial", "zone_picking", "recorder_agent", "finance"],
  enterprise: ["lot_serial", "zone_picking", "recorder_agent", "finance"],
};

export function planAllows(
  plan: Workspace["plan"] | undefined,
  f: Feature,
): boolean {
  return plan !== undefined && features[plan].includes(f);
}
